import {Col, Row} from "antd";
import React from "react";
import {CourierCodPaymentSettings} from "./courierCodPaymentSettings/CourierCodPaymentSettings";
import {CourierPOSRecords} from "./courierPOSRecords/CourierPOSRecords";

export const CourierCodPaymentTab = ({
    courier,
    courierLoading = true,
    reloadCourier = () => {}
}) => {
    return (
        <div>
            <Row gutter={[20, 20]}>
                <Col xs={24} sm={24} md={24} lg={8} xl={5} span={5}>
                    <CourierCodPaymentSettings
                        courier={courier}
                        courierLoading={courierLoading}
                        reloadCourier={reloadCourier}
                    />
                </Col>
                <Col xs={24} sm={24} md={24} lg={16} xl={18} span={5}>
                    <CourierPOSRecords courier={courier} courierLoading={courierLoading} />
                </Col>
            </Row>
        </div>
    );
};
